import {css} from 'styled-components';

export const storeCommonStyles = css`
    --brand-color-teal: #1FB6C6;
    --brand-color-teal-light: #f0fffe;
    --brand-color-midnight-blue: #004b6e;
    --primary: #1890ff;         /* blue-6 */
    --primary-1: #e6f7ff;  /* blue-1 */
    --primary-2: #bae7ff;  /* blue-2 */
    --primary-3: #91d5ff;  /* blue-3 */
    --primary-4: #69c0ff;  /* blue-4 */
    --primary-7: #096dd9;  /* blue-7 */
    --primary-8: #0050b3;   /* blue-8 */
    --primary-10: #002766;  /* blue-10 */
    --neutralDarkest: #434343;   /* gray-9 */
    --neutralDarker: #595959;   /* gray-8 */
    --neutralDark: #8c8c8c;     /* gray-7 */
    --neutral: #d9d9d9;         /* gray-5 */
    --neutralLight: #f0f0f0;    /* gray-4 */
    --neutralLighter: #f5f5f5;  /* gray-3 */
    --neutralLightest: #fafafa; /* gray-2 */

    .ant-image {
        position: relative;

        /* wdith: 100%; */
        padding-top: 100%;  /* aspect ratio 1:1 */
  
        /* aspect ratio 1:1 */
        .image {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .image__placeholder {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 1em;
            font-weight: 500;
            text-align: center;
        }
    }

    .none {
        display: none;
    }

    .flex-center {
        display: flex;
        align-self: center;
        justify-content: center;
    }

    .center-vertically {
        display: flex;
        align-items: center;
    }

    .center-horizontally {
        display: flex;
        justify-content: center;
    }

    .pre-wrap {
        white-space: pre-wrap;
    }

    .aspect-ratio-1-1-container {
        position: relative;
        padding-top: 100%;

        .aspect-ratio-1-1-children {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .wrapper__white-background {
        padding: 1rem;
        background: white;
        border-radius: 9px;
    }
  
`;
